import React, { useContext, useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import { SessionContext } from '../../common/SessionContext';

function Plus7DetailsTab(props) {

    return (
        <div
            className="tab-pane fade show active package-info-tab"
            id="pill-body1"
            role="tabpanel"
            aria-labelledby="pills-package1"
        >
            <h3 className="d-subtitle has-bg-image">Add an extra week to your CAMP stay</h3>
            <div className="workshop_bodytext has-bg-image">
                <p>When the workshop ends, and we jump in the vans back to Toulouse, we guarantee you're going to feel the energy of those mountains pulling you back! Nobody ever wants to leave CAMP after 5 days - well, now you don't have to! Instead of leaving on the Monday after your workshop ends, stay another week, decompress, go hiking, swimming in the rivers, use our equipment and facilities, work on your projects, and process what happened during your workshop.</p>
                <p><strong>Full board</strong></p>
                <p>During your extra week in the mountains, enjoy the same excellent catering as you did the week before - all diets catered for. You can also prepare packed lunches to take out on hikes, or even visit the local restaurant.</p>

                <p><strong>Unlimited facilities use</strong></p>
                <p>For these 7 days, our place is your place - pick a space to work in, set some equipment up, and get to work on your projects.</p>

                <p><strong>Explore the Pyrenees</strong></p>
                <p>Aulus les Bains is an excellent base for day hikes, and even more so for multi-day treks. Our team can guide you in planning an epic trip into some of the most beautiful mountains in Europe, using CAMP as your base.</p>

                <p><strong>Transport back to Toulouse</strong></p>
                <p>Your transport back to Toulouse is still part of the deal - we'll just leave a week later, arriving in Toulouse by 11am on the following Monday.</p>

                <p><strong>The price</strong></p>
                <p>Add 7 days to your stay for €349 / £299 / $379. The best time to add +7 to your stay is when you first confirm your booking - that way you can split the cost along with your workshop fee, and if you get a grant, the discount is applied to the extra cost as well. If you decide to add +7 later on, you can do that easily in the CAMP Hub.</p>

            </div>

        </div>
    );
}

export default Plus7DetailsTab;
